import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Input,
  Dropdown,
  Form,
  TextArea
} from 'semantic-ui-react'

const DiagnosisTodayUX = React.forwardRef((props: any, ref: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div>
        <div
          style={{ display: "flex", height: "100%", padding: "10px" }}>
          <div
            style={{ flex: 1 }}>
            <div
              style={{ flex: 1, margin: "5px" }}>
              <div
                style={{ fontWeight: "bold",  padding:"5px 0" }}>
                {props.languageUX === "en" ? "Chief Complaints" : "Chief Complaints"}
                <Button
                  color={"orange"}
                  disabled={props.disabledReExam}
                  onClick={props.onReExamination}
                  size="tiny"
                  style={{marginLeft: "15px", padding:"5px"}}>
                  {props.languageUX === "en" ? "Re-Examination" : "Re-Examination"}
                </Button>
                <Button
                  color="blue"
                  icon="setting"
                  onClick={props.onTemplateChiefComplaint}
                  size="tiny"
                  style={{marginLeft: "10px", padding:"5px"}}>
                </Button>
              </div>
              <Form>
                <TextArea
                  name="chief_complaints"
                  onChange={(e) => { props.handleOnMedicalHistoryChange("chief_complaints", e.target.value)}}
                  onKeyDown={props.onSetTemplateKeyboardShortcut}
                  readOnly={props.readOnly}
                  style={{ width: "100%", ...props.backgroundColorTextArea}}
                  value={props.medicalHistoryList?.chief_complaints || ""}>
                </TextArea>
              </Form>
            </div>
            <div
              style={{ flex: 1, margin: "5px" }}>
              <div
                style={{ fontWeight: "bold", padding:"5px 0" }}>
                {props.languageUX === "en" ? "Present illness" : "Present illness"}
              </div>
              <Form>
                <TextArea
                  onChange={(e) => { props.handleOnMedicalHistoryChange("present_illness", e.target.value)}}
                  readOnly={props.readOnly}
                  style={{ width: "100%", ...props.backgroundColorTextArea}}
                  value={props.medicalHistoryList?.present_illness || ""}>
                </TextArea>
              </Form>
            </div>
            <div
              style={{flex:1, margin:"5px"}}>
              <div
                style={{fontWeight:"bold", padding:"5px 0"}}>
                {props.languageUX === "en" ? "Medical History" : "Medical History"}
              </div>
              <Form>
                <TextArea
                  onChange={(e) => { props.handleOnMedicalHistoryChange("additional_comment", e.target.value)}}
                  readOnly={props.readOnly}
                  style={{ width: "100%", ...props.backgroundColorTextArea}}
                  value={props.medicalHistoryList?.additional_comment || ""}>
                </TextArea>
              </Form>
            </div>
          </div>
          <div
            style={{ height: "100%", flex: 1, display: "none", flexDirection: "column"}}>
            <div
              style={{ margin: "5px", display: "flex", alignItems: "flex-start" }}>
              <div
                style={{ flex: 1, backgroundColor: "#2D9CDB",  color: "white", marginRight: "10px" }}>
                {props.languageUX === "en" ? "PSR" : "PSR"}
              </div>
              <div
                style={{ flex: 3, display: "grid", gridTemplateColumns: "repeat(4, 25%)", gridTemplateRows: "repeat(2, 50%)" }}>
                <div
                  style={{ gridRow: 1, gridColumn: 1 }}>
                  <Input
                    fluid={true}
                    onChange={(e) => { props.setProp(`encounterList.${props.encounterIndex}.psr_s1`, e.target.value) }}
                    value={props.encounter?.psr_s1}>
                  </Input>
                </div>
                <div
                  style={{ gridRow: 1, gridColumn: 2 }}>
                  <Input
                    fluid={true}
                    onChange={(e) => { props.setProp(`encounterList.${props.encounterIndex}.psr_s2`, e.target.value) }}
                    value={props.encounter?.psr_s2}>
                  </Input>
                </div>
                <div
                  style={{ gridRow: 1, gridColumn: 3 }}>
                  <Input
                    fluid={true}
                    onChange={(e) => { props.setProp(`encounterList.${props.encounterIndex}.psr_s3`, e.target.value) }}
                    value={props.encounter?.psr_s3}>
                  </Input>
                </div>
                <div
                  style={{ gridRow: 2, gridColumn: 1 }}>
                  <Input
                    fluid={true}
                    onChange={(e) => { props.setProp(`encounterList.${props.encounterIndex}.psr_s6`, e.target.value) }}
                    value={props.encounter?.psr_s6}>
                  </Input>
                </div>
                <div
                  style={{ gridRow: 2, gridColumn: 2 }}>
                  <Input
                    fluid={true}
                    onChange={(e) => { props.setProp(`encounterList.${props.encounterIndex}.psr_s5`, e.target.value) }}
                    value={props.encounter?.psr_s5}>
                  </Input>
                </div>
                <div
                  style={{ gridRow: 2, gridColumn: 3 }}>
                  <Input
                    fluid={true}
                    onChange={(e) => { props.setProp(`encounterList.${props.encounterIndex}.psr_s4`, e.target.value) }}
                    value={props.encounter?.psr_s4}>
                  </Input>
                </div>
                <div
                  style={{ margin: "5px", gridRow: 1, gridColumn: 4 }}>
                  {props.languageUX === "en" ? "Upper" : "Upper"}
                </div>
                <div
                  style={{ margin: "5px", gridRow: 2, gridColumn: 4 }}>
                  {props.languageUX === "en" ? "Lower" : "Lower"}
                </div>
              </div>
            </div>
            <div
              style={{ margin: "5px", display: "flex", alignItems: "flex-start" }}>
              <div
                style={{ flex:"0 0 25%", backgroundColor: "#2D9CDB", color: "white" , marginRight: "10px" }}>
                {props.languageUX === "en" ? "Occlusion" : "Occlusion"}
              </div>
              <Dropdown
                onChange={(e, v) => { props.setProp(`encounterList.${props.encounterIndex}.occlusion_classification`, v.value) }}
                options={props.occlusionOptions}
                selection={true}
                style={{ flex: "0 0 75%", width: "100%" }}
                value={props.encounter?.occlusion_classification}>
              </Dropdown>
            </div>
          </div>
        </div>
        <div
          style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            color="blue"
            onClick={(e) => { props.summaryPreview() }}
            style={{ display: "none" }}>
            {props.languageUX === "en" ? "Summary Preview" : "Summary Preview"}
          </Button>
          <Button
            color="green"
            disabled={props.disabledSave}
            onClick={props.saveDiagnosis}
            size="small">
            {props.languageUX === "en" ? "Save" : "Save"}
          </Button>
        </div>
      </div>
    )
})

DiagnosisTodayUX.displayName = "DiagnosisTodayUX";
export default React.memo(DiagnosisTodayUX)

export const screenPropsDefault = {"diagnosis":"tooth cavity"}

/* Date Time : Tue Sep 10 2024 10:27:38 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "Chief Complaints",
          "valueEN": "Chief Complaints"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\",  padding:\"5px 0\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "Save",
          "valueEN": "Save"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledSave"
        },
        "onClick": {
          "type": "code",
          "value": "props.saveDiagnosis"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 0,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", height: \"100%\", padding: \"10px\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 19,
      "props": {
        "style": {
          "type": "code",
          "value": "{ flex: 1, margin: \"5px\" }"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 20,
      "props": {
        "style": {
          "type": "code",
          "value": "{ margin: \"5px\", display: \"flex\", alignItems: \"flex-start\" }"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 0,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 19,
      "props": {
        "style": {
          "type": "code",
          "value": "{ flex: 1, margin: \"5px\" }"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 20,
      "props": {
        "style": {
          "type": "code",
          "value": "{ margin: \"5px\", display: \"flex\", alignItems: \"flex-start\" }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "Present illness",
          "valueEN": "Present illness"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", padding:\"5px 0\" }"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 7,
      "props": {
        "style": {
          "type": "code",
          "value": "{ flex: 1 }"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 7,
      "props": {
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", flex: 1, display: \"none\", flexDirection: \"column\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "PSR",
          "valueEN": "PSR"
        },
        "style": {
          "type": "code",
          "value": "{ flex: 1, backgroundColor: \"#2D9CDB\",  color: \"white\", marginRight: \"10px\" }"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 9,
      "props": {
        "style": {
          "type": "code",
          "value": "{ flex: 3, display: \"grid\", gridTemplateColumns: \"repeat(4, 25%)\", gridTemplateRows: \"repeat(2, 50%)\" }"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 56,
      "props": {
        "style": {
          "type": "code",
          "value": "{ gridRow: 1, gridColumn: 1 }"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 56,
      "props": {
        "style": {
          "type": "code",
          "value": "{ gridRow: 1, gridColumn: 2 }"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 56,
      "props": {
        "style": {
          "type": "code",
          "value": "{ gridRow: 1, gridColumn: 3 }"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 56,
      "props": {
        "style": {
          "type": "code",
          "value": "{ gridRow: 2, gridColumn: 1 }"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 56,
      "props": {
        "style": {
          "type": "code",
          "value": "{ gridRow: 2, gridColumn: 2 }"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 56,
      "props": {
        "style": {
          "type": "code",
          "value": "{ gridRow: 2, gridColumn: 3 }"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": "Upper",
          "valueEN": "Upper"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px\", gridRow: 1, gridColumn: 4 }"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": "Lower",
          "valueEN": "Lower"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px\", gridRow: 2, gridColumn: 4 }"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Input",
      "parent": 57,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "(e) => { props.setProp(`encounterList.${props.encounterIndex}.psr_s1`, e.target.value) }"
        },
        "size": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.encounter?.psr_s1"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "Input",
      "parent": 58,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "(e) => { props.setProp(`encounterList.${props.encounterIndex}.psr_s2`, e.target.value) }"
        },
        "value": {
          "type": "code",
          "value": "props.encounter?.psr_s2"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "Input",
      "parent": 59,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "(e) => { props.setProp(`encounterList.${props.encounterIndex}.psr_s3`, e.target.value) }"
        },
        "value": {
          "type": "code",
          "value": "props.encounter?.psr_s3"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "Input",
      "parent": 60,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "(e) => { props.setProp(`encounterList.${props.encounterIndex}.psr_s6`, e.target.value) }"
        },
        "value": {
          "type": "code",
          "value": "props.encounter?.psr_s6"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "Input",
      "parent": 61,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "(e) => { props.setProp(`encounterList.${props.encounterIndex}.psr_s5`, e.target.value) }"
        },
        "value": {
          "type": "code",
          "value": "props.encounter?.psr_s5"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Input",
      "parent": 62,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "(e) => { props.setProp(`encounterList.${props.encounterIndex}.psr_s4`, e.target.value) }"
        },
        "value": {
          "type": "code",
          "value": "props.encounter?.psr_s4"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "Occlusion",
          "valueEN": "Occlusion"
        },
        "style": {
          "type": "code",
          "value": "{ flex:\"0 0 25%\", backgroundColor: \"#2D9CDB\", color: \"white\" , marginRight: \"10px\" }"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "Dropdown",
      "parent": 14,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, v) => { props.setProp(`encounterList.${props.encounterIndex}.occlusion_classification`, v.value) }"
        },
        "options": {
          "type": "code",
          "value": "props.occlusionOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ flex: \"0 0 75%\", width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.encounter?.occlusion_classification"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 19,
      "props": {
        "style": {
          "type": "code",
          "value": "{flex:1, margin:\"5px\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 76,
      "props": {
        "children": {
          "type": "value",
          "value": "Medical History",
          "valueEN": "Medical History"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"bold\", padding:\"5px 0\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "Form",
      "parent": 8,
      "props": {
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "Form",
      "parent": 13,
      "props": {
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "Form",
      "parent": 76,
      "props": {
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "TextArea",
      "parent": 79,
      "props": {
        "name": {
          "type": "value",
          "value": "chief_complaints"
        },
        "onChange": {
          "type": "code",
          "value": "(e) => { props.handleOnMedicalHistoryChange(\"chief_complaints\", e.target.value)}"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.onSetTemplateKeyboardShortcut"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", ...props.backgroundColorTextArea}"
        },
        "value": {
          "type": "code",
          "value": "props.medicalHistoryList?.chief_complaints || \"\""
        }
      },
      "seq": 84,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "TextArea",
      "parent": 80,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e) => { props.handleOnMedicalHistoryChange(\"present_illness\", e.target.value)}"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", ...props.backgroundColorTextArea}"
        },
        "value": {
          "type": "code",
          "value": "props.medicalHistoryList?.present_illness || \"\""
        }
      },
      "seq": 85,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "TextArea",
      "parent": 81,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e) => { props.handleOnMedicalHistoryChange(\"additional_comment\", e.target.value)}"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", ...props.backgroundColorTextArea}"
        },
        "value": {
          "type": "code",
          "value": "props.medicalHistoryList?.additional_comment || \"\""
        }
      },
      "seq": 86,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "Summary Preview",
          "valueEN": "Summary Preview"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "onClick": {
          "type": "code",
          "value": "(e) => { props.summaryPreview() }"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"none\" }"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "Button",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "Re-Examination",
          "valueEN": "Re-Examination"
        },
        "color": {
          "type": "code",
          "value": "\"orange\""
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledReExam"
        },
        "onClick": {
          "type": "code",
          "value": "props.onReExamination"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\", padding:\"5px\"}"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "Button",
      "parent": 1,
      "props": {
        "color": {
          "type": "value",
          "value": "blue"
        },
        "icon": {
          "type": "value",
          "value": "setting"
        },
        "onClick": {
          "type": "code",
          "value": "props.onTemplateChiefComplaint"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\", padding:\"5px\"}"
        }
      },
      "seq": 91,
      "void": false
    }
  ],
  "forwardRef": true,
  "height": 80,
  "isMounted": true,
  "memo": true,
  "name": "DiagnosisTodayUX",
  "project": "cudent",
  "screenPropsDefault": {
    "diagnosis": "tooth cavity"
  },
  "width": 80
}

*********************************************************************************** */
